import type { TerminalPasswordDto } from "../../types/TerminalPasswordDto";
import type { TerminalPasswordEntity } from "../../types/TerminalPasswordEntity";

export const TerminalPasswordEntityToDto = ({ ...rest }: Readonly<TerminalPasswordEntity>): TerminalPasswordDto => {
    return { ...rest };
};
